import { OrderApplicants } from '@flatsy/utils/Functions/ApplicationUtils/OrderApplicant'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const getLatestData = (context: WizardContext, event: WizardEvent): WizardContext => {
  let qualificationData = context.qualification
  let applicantData = context.applicants
  let assetData = context.asset
  let applicationData = context.application
  if (event && event.value && event.value.qualification) {
    qualificationData = event.value.qualification
  }
  if (event && event.value && event.value.applicants) {
    applicantData = OrderApplicants(event.value.applicants)
  }
  if (event && event.value && event.value.asset) {
    assetData = event.value.asset
  }
  if (event && event.value && event.value.application) {
    applicationData = event.value.application
  }

  return {
    ...context,
    qualification: qualificationData,
    applicants: applicantData,
    asset: assetData,
    application: applicationData,
  }
}
